<div class="submission-instructions-changes-card">
  <div class="d-flex flex-column gap-2">
    <div class="submission-instructions-changes-title" i18n>Investment Instructions</div>
    <div *ngIf="investmentInstructionsHaveChanged$ | async" class="submission-instructions-changes-description" i18n>
      {{ descriptionText }}
    </div>
    <div *ngIf="!(investmentInstructionsHaveChanged$ | async)" class="submission-instructions-changes-description" i18n>
      No Changes
    </div>
  </div>
  <ng-container *ngIf="investmentInstructionsHaveChanged$ | async">
    <app-investment-instructions-visualization
      [instructions]="previousInvestmentInstructions$ | async"
      [forcedColumns]="2"
      [cardBorderColour]="'transparent'"
      [cardBackgroundColour]="'#FFEAEB'"
      label="Previous"
      i18n-label />
    <hr class="instruction-separator" />
    <app-investment-instructions-visualization
      [instructions]="newInvestmentInstructions$ | async"
      [forcedColumns]="2"
      [cardBorderColour]="'transparent'"
      [cardBackgroundColour]="'#E8F7D9'"
      label="New"
      i18n-label />
  </ng-container>
</div>
